import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { CartProvider } from "@/context/CartContext";
import { Nav } from "@/components/sections/Nav";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Bio } from "@/components/sections/Bio";
import { Music } from "@/components/sections/Music";
import { Tour } from "@/components/sections/Tour";
import { Merch } from "@/components/sections/Merch";
import { Press } from "@/components/sections/Press";
import { Newsletter } from "@/components/sections/Newsletter";
import { Footer } from "@/components/sections/Footer";
import { CartDrawer } from "@/components/sections/CartDrawer";
import { Lightning } from "@/components/sections/Lightning";
import SuccessPage from "@/pages/SuccessPage";

const HomePage = () => (
  <div data-testid="home-page" className="relative bg-ink-950 text-white grain min-h-screen">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Bio />
      <Music />
      <Tour />
      <Merch />
      <Press />
      <Newsletter />
    </main>
    <Footer />
    <CartDrawer />
    <Lightning />
  </div>
);

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/success" element={<SuccessPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0E17",
            border: "1px solid rgba(212,175,55,0.3)",
            color: "#F8FAFC",
          },
        }}
      />
    </CartProvider>
  );
}

export default App;
